<template>
    <div :style="vjsStyle">
      <video
        id="vid1"
        class="vjs-wfs video-js vjs-default-skin"
        :poster="poster"
        controls
        :autoplay="autoplay"
        :width="widthStyle"
        :height="heightStyle"
      />
    </div>
</template>

<script>
  import videojs from 'video.js'
  import 'video.js/dist/video-js.min.css'
  import 'videojs-youtube/dist/Youtube.js';

  export default {
    props: {
      source:{
        type: String,
        default: ''
      },
      poster: {
        type: String,
        default: '/img/video-placeholder.jpg'
      },
      options: {
        type: Object,
        default() {
          return {};
        }
      },
      themeColor: {
        type: Object,
        default() {
          return {};
        }
      },
      width: {
        type: Object,
        default() {
          return {};
        }
      },
      height: {
        type: Object,
        default() {
          return {};
        }
      },
      color: {
        type: String,
        default: '#00ff00'
      },
      autoplay:{
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        player: null,
      }
    },
    mounted() {
      if (! this.player) {
        return this.$nextTick(() => {
          this.player = this.initVideoPlayer()
          //this.player.qualityLevels()
        })
      }
    },

    watch: {
      source(value) {
        if (! value) {
          return
        }
        if (! this.player) {
          return this.$nextTick(() => {this.player = this.initVideoPlayer()})
        }
        console.log(this.videoSrc, 'videoSrc....');
        this.player.src(this.videoSrc)
      },
    },

    computed: {
      widthStyle() {
        return this.width.width
      },
      heightStyle() {
        return this.height.height
      },

      vjsStyle() {
        const color = this.themeColor.color
        return {
          '--wfs-vjs': color,
          '--wfs-vjs-rgba': color
        }
      },

      videoSrc() {
        let src = {src: this.source, type: 'video/mp4'}
        let pattern = /youtu(be\.com|\.be)/g
        if (pattern.test(this.source)) {
          this.$set(src, 'type', "video/youtube")
        }
        return src
      },
    },

    methods: {
      convertHex: function (color) {
        color = color.replace('#', '')
        let r = parseInt(color.substring(0, 2), 16)
        let g = parseInt(color.substring(2, 4), 16)
        let b = parseInt(color.substring(4, 6), 16)
        return 'rgba(' + r + ',' + g + ',' + b + ',' + 90 / 100 + ')'
      },

      initVideoPlayer() {
        return videojs('vid1', {
          techOrder: ['youtube', 'html5'],
          autoplay: this.autoplay,
          controls: true,
          sources: [this.videoSrc],
          youtube: {
            origin: 'http://localhost:8080',
            loop: 1,
            autoplay: this.autoplay,
            controls: 0,
            disablekb: 1,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            rel:0
          }
        })
      }
    },
    beforeDestroy() {
      if (this.player) this.player.dispose()
    }
  }
</script>

<style lang="css" scoped>
  .vjs-wfs {
    color: var(--wfs-vjs) !important;
  }

    /* Change the border of the big play button. */
  .vjs-wfs, .video-js .vjs-big-play-button {
    border-color: var(--wfs-vjs) !important;
  }

  .vjs-wfs  .vjs-slider {
    background-color: var(--wfs-vjs);
    border-radius: 1em;
  }

  .vjs-wfs .vjs-volume-level,
  .vjs-wfs .vjs-play-progress,
  .vjs-wfs .vjs-slider-bar {
    background: var(--wfs-vjs) !important;
  }

  .vjs-wfs .vjs-play-progress,
  .video-js .vjs-play-progress {
    background-color: var(--wfs-vjs) !important;
  }

  .vjs-wfs .vjs-control-bar,
  .video-js .vjs-control-bar{
    background-color: var(--wfs-vjs) !important;
  }
</style>
